"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxState = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var CheckboxState;
(function (CheckboxState) {
    CheckboxState["All"] = "All";
    CheckboxState["None"] = "None";
    CheckboxState["Some"] = "Some";
})(CheckboxState || (exports.CheckboxState = CheckboxState = {}));
var CheckBoxComponent = (function (_super) {
    __extends(CheckBoxComponent, _super);
    function CheckBoxComponent() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.renderMark = function () {
            switch (_this.props.selectionState) {
                case CheckboxState.All:
                    return react_1.default.createElement(icons_1.Tick, { size: icons_1.IconSize.Small, className: "selectall-checkbox__tick" });
                case CheckboxState.Some:
                    return react_1.default.createElement(icons_1.ListMarkerSquare, { size: icons_1.IconSize.Small, className: "selectall-checkbox__square" });
                case CheckboxState.None:
                    return react_1.default.createElement(react_1.default.Fragment, null);
            }
        };
        _this.handleOnClick = function (event) {
            _this.props.handleOnClick("clicked", event);
        };
        return _this;
    }
    CheckBoxComponent.prototype.render = function () {
        var selectionState = this.props.selectionState;
        var checkboxBoxClasses = (0, classnames_1.default)({
            "selectall-checkbox__box": true,
            "selectall-checkbox__box--all": selectionState === CheckboxState.All,
            "selectall-checkbox__box--none": selectionState === CheckboxState.None,
            "selectall-checkbox__box--some": selectionState === CheckboxState.Some,
        });
        return (react_1.default.createElement("div", { className: "selectall-checkbox", onClick: this.handleOnClick },
            react_1.default.createElement("div", { className: "selectall-checkbox__click-field" },
                react_1.default.createElement("div", { className: checkboxBoxClasses },
                    react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, in: true, timeout: kaleidoscope_1.AnimationDuration.Medium, classNames: "selectall-checkbox__box-actions-" }, this.renderMark())))));
    };
    CheckBoxComponent.defaultProps = {
        selectionState: CheckboxState.None,
    };
    CheckBoxComponent = __decorate([
        mobx_react_1.observer
    ], CheckBoxComponent);
    return CheckBoxComponent;
}(react_1.default.Component));
exports.default = CheckBoxComponent;
